<template>
  <div class="slide-box">
    <!-- <template v-if="list.length">
      <button type="button" v-if="activeIndex > 0" class="slide-arrow slide-arrow--left" @click="clickPrev"><i class="el-icon-arrow-left"></i></button>
      <button type="button" v-if="(activeIndex + 1) !== list.length" class="slide-arrow slide-arrow--right" @click="clickNext"><i class="el-icon-arrow-right"></i></button>
    </template> -->
    <el-carousel class="supplier-slide"
                 ref="citySlide"
                 height="570px"
                 :autoplay="false"
                 arrow1="always"
                 arrow="never"
                 trigger="click"
                 indicator-position="outside"
                 @change="(val) => activeIndex = val"
    >
      <el-carousel-item class="supplier-slide__item"
                        v-for="(hotcityItem,index) in list"
                        :key="index">
        <!-- <div class="hotlist" style="width: 100%; overflow: hidden"> -->
        <div class="hotlist" style="width: 100%;">
          <div
            id="baiDu_hotcountry"
            class="Hotcounter"
            :class="(index + 1) % 4 ? '' : 'no-r-m'"
            style="cursor: pointer"
            v-for="(item, index) in hotcityItem"
            :key="index"
            @click="clickItem(item)"
            :title="item.status === 1 ? '' : '筹备中'"
          >
            <!-- <el-card
              class="SlowAlterBac"
              shadow="hover"
              style="height: 120px; width: 100%"
            >
              <div style="display: flex;justify-content: center;align-items: center;">
                <div :class="{'is-opacity':item.status !== 1}"
                     style="min-width: 40px">
                  <img
                    style="width: 80px; height: 80px; border-radius: 20px;object-fit: contain;"
                    :src="item.imgurl||defaultIcon"
                    alt="国家"
                  />
                </div>
                <div style="min-width: 110px;padding-left:20px;box-sizing: border-box;">
                  <div
                    :style="{color: setColor == index ? '#ffffff' : '#333333'}"
                    style="margin-bottom: 10px;font-size: 18px;font-weight: bold;color: #333333;width: 136px;"
                  >
                    {{ item.countryNamec }}
                    <el-tooltip
                      v-if="item.status === 1"
                      popper-class="txt-1"
                      class="item"
                      effect="light"
                      :content="item.concernSign ? '取消收藏' : '收藏'"
                      placement="bottom"
                    >
                                  <span
                                    :class="item.concernSign? 'icon_collect_pre': 'icon_collect'"
                                    :style="{ color: item.concernSign ? '#FFBF4D' : '' }"
                                    style="float: right; font-size: 20px"
                                    @click.stop="followItem(item)"
                                  ></span>
                    </el-tooltip>
                  </div>
                  <price-blurring
                    v-if="item.status === 1"
                    :price-display-type="item.priceDisplayType"
                    :currency="item.currency"
                    :price="item.lowestPrice"
                    :unit="item.chargeType"
                    class="price-style"
                    @priceClick="clickItem(item)"
                  />
                </div>
              </div>
            </el-card> -->
            <div class="country-card">
              <img class="country-flag" :src="item.imgurl||defaultIcon" alt="">
              <el-tooltip
                      v-if="item.status === 1"
                      effect="dark"
                      :content="item.concernSign ? '取消收藏' : '收藏即可订阅国家推送'"
                      placement="top-start"
                    >
                                  <span
                                    :class="item.concernSign? 'icon_collect_pre': 'icon_collect'"
                                    :style="{ color: item.concernSign ? '#FFBF4D' : '' }"
                                    style="float: right; font-size: 20px"
                                    @click.stop="followItem(item)"
                                  ></span>
                    </el-tooltip>
              <div class="country-info">
                  <div>{{ item.countryNamec }}</div>
                  <price-blurring
                    v-if="item.status === 1"
                    :price-display-type="item.priceDisplayType"
                    :currency="item.currency"
                    :price="item.lowestPrice ? item.lowestPrice : item.currency && '单询'"
                    :unit="item.chargeType"
                    class="price-style"
                    :customPriceStyle="{ 'font-size': item.currency ? '16px' : '24px' }"
                    @priceClick="clickItem(item)"
                  />
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import {isObject} from "my-tools-kit";
import {ossPath} from "../../../../../devParams";
import {mapGetters, mapState} from "vuex";
import PriceBlurring from "../../../../../common/priceBlurring";
import {sendCustomerOperationRecord} from "@/assets/js/utils";
import {confirmGoRealName} from "@/assets/js/utils.realName";

export default {
  name: "homeHotCountry",
  components: {PriceBlurring},
  props:{
    list:{
      type:Array,
      default:()=>[]
    },
  },
  data(){
    return {
      defaultIcon:ossPath + "/pages/home/hot_country_default_icon.png",
      activeIndex: null,
      setColor: -1,
    }
  },
  computed: {
    ...mapGetters(["token","realNameState"]),
  },
  methods:{

    clickPrev(){
      this.$refs.citySlide.prev();
    },
    clickNext(){
      this.$refs.citySlide.next();
    },
    // 国家关注
    followItem (item) {
      console.log("item: ", item)
      if (item.concernSign) {
        //取消关注
        return this.CancelAttention(item);
      }
      if(this.token){
        if(this.realNameState !== 3) {
          confirmGoRealName(this.realNameState);
          return false;
        }
      }
      sendCustomerOperationRecord("收藏",`国家名称:${item.countryNamec}`)
      let data = {
        productOrCountryId: item.countryId,
        refType: 2,
      }
      let url = "/api/product/concernProductOrCountry";
      this.axios.post(url, data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.$message.success("收藏成功");
          this.$emit("concern");
          this.$root.Bus.$emit('refreshFavoritesCountry')
        })
        .catch(res => {
          this.$message.error(`收藏：${res.message||'服务器繁忙'}`);
        })
    },
    // 取关
    CancelAttention (item) {
      let data = {
        productOrCountryId: item.countryId,
        refType: 2,
      }
      sendCustomerOperationRecord("取消收藏",`国家名称:${item.countryNamec}`)
      let url = "/api/product/cancelConcernProductOrCountry";
      this.axios.post(url, data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.$message.success("取消收藏成功");
          this.$emit("cancelConcern");
          this.$root.Bus.$emit('refreshFavoritesCountry')
        })
        .catch(res => {
          this.$message.error(`取消收藏：${res.message||'服务器繁忙'}`);
        })
    },
    /**
     * 点击 国家item
     * @param item
     */
    clickItem(item){
      if(item.status !== 1)  {
        return this.$message.error(`${item.countryNamec||""}正在筹备中，敬请期待！`);
      }
      this.$emit("clickItem",item)
    },
    noEvent(){},
  }
}
</script>

<style scoped lang="scss">
.slide-box{
  position: relative;
  overflow: visible;
  // padding: 0 20px;
  // padding-right: 20px;
}
/*左右箭头*/
.slide-arrow{
  display: none;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  -webkit-transition: .3s;
  transition: .3s;
  border-radius: 50%;
  color: #fff;
  position: absolute;
  //top: 50%;
  top: 210px;
  z-index: 10;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
  font-size: 12px;
  width: 45px;
  height: 45px;
  background-color: white;
  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.05);
  &:hover{
    background-color: #eaf9f8;
    i{
      color: #FF4D01;
    }
  }
  i{
    cursor: pointer;
    color: #666;
    font-size: 24px;
    font-weight: bold;
  }

  //&--left {
  //  left: 16px;
  //}
  //&--right {
  //  right: 16px;
  //}
  @media screen and (min-width: (1200px + 76px * 2)){
    &{
      display: block;
    }
    &--left{
      left: -22px;
    }
    &--right{
      right: -22px;
    }
  }
}

.supplier-slide{
  width: 100%;
  &__item{
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-carousel__container {
    // border: 1px solid #EEEEEE;
    z-index: 0;
  }

  /*指示器*/
  /deep/ .el-carousel__indicators{
    padding: 30px - 12px 0;
  }
  /deep/ .el-carousel__indicator{

    .el-carousel__button{
      background: #D8D8D8;
      width: 80px;
      height: 6px;
      // border-radius: 2px;
      opacity: 1;
      &:hover{
        background-color: #999;
      }
    }
    &.is-active{
      .el-carousel__button{
        background: #FF4D01 !important;
      }
    }
  }
}
.supplier-slide__item {
  // border: 1px solid #EEEEEE
  // width: calc(100% - 2px);
  padding: 10px;
  padding-top: 30px;
  padding-bottom: 0;
  width: calc(100% - 22px);
}

.hotlist {
  width: 100%;
  float: left;
  // display: flex;
  // justify-content: space-between;
  // flex-wrap: wrap;
}

.Hotcounter {
  // width: 25%;
  margin-right: 40px;
  width: 264px;
  box-sizing: border-box;
  float: left;
  // padding: 0 10px;
  // height: 140px;
  // margin-bottom: 18px;
  position: relative;
  border-radius: 30px;
  &.no-r-m{
     margin-right: 0;
  }
}
.Hotcounter >>> .el-card__body {
  padding: 20px;
}
.el-card {
  border: none;
  transition: ease 0.4s;
}
.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
  border: none;
  -webkit-box-shadow: 0 2px 12px 0 rgba(254, 226, 228, .9);
  box-shadow: 0 2px 12px 0 rgba(254, 226, 228, .9);
  z-index: 1
}

.SlowAlterBac {
  transform: translateZ(0);
  position: relative;
  transition-property: color;
  transition-duration: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.SlowAlterBac:active, .SlowAlterBac:focus, .SlowAlterBac:hover {
  color: #fff;
  // border: 1px solid rgba(254, 226, 228, 1);
  -webkit-box-shadow: 4px 4px 4px 0 rgba(254, 226, 228, 1);
  box-shadow: 4px 4px 4px 0 rgba(254, 226, 228, 1);
  z-index: 1
}

.SlowAlterBac:active:before, .SlowAlterBac:focus:before, .SlowAlterBac:hover:before {
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}
.is-opacity{
  opacity: 0.5;
}

.icon_collect {
  width: 22px;
  height: 21px;
  display: inline-block;
  background: url('../../../../assets/icon_collect.png') no-repeat;
  opacity: .6;
}
.icon_collect_pre {
  width: 22px;
  height: 21px;
  display: inline-block;
  background: url('../../../../assets/icon_collect_pre.png') no-repeat;
}
.price-style{
  color: #FF4D01;
  font-weight: bold;
  /deep/ .price-blurring--box{
    .price-blurring--currency{
      font-size: 15px;
      color: #111111;
      font-weight: 400;
    }
    .price-blurring--price{
      font-size: 24px;
    }
    .price-blurring--unit{
      font-size: 15px;
      color: #111111;
      font-weight: 400;
    }
  }

}
.country-card {
  position: relative;
  padding: 10px 10px;
  height: 100px;
  width: calc(100% - 20px);
  margin-right: 48px;
  margin-bottom: 79px;
  border: none;
  transition: ease 0.4s;
  box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  color: #111111;
  font-size: 18px;
  font-weight: 400;
  &:hover {
    background: #FF4D01;
    color: #fff;
    .price-style {
      color: #FFBF39
    }
    /deep/ .price-blurring--currency{
      color: #FFFFFF
    }
    /deep/ .price-blurring--unit{
      color: #FFFFFF
    }
    .icon_collect {
      background: url('../../../../assets/icon_collect-hover.png') no-repeat;
      opacity: 1;
    }
  }
  .country-flag{
    width: 120px;
    height: 75px;
    position: absolute;
    top: -27px;
    left: 10px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
    border-radius: 4px;
    border: 0;
  }
  .country-info {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 20px);
    position: absolute;
    bottom: 20px;
  }
}
// .el-carousel--horizontal {
//   overflow: initial;
// }
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeHotCountry/index.vue